import { AlertCircle, LucideIcon } from "lucide-react"
import { Label } from "@/components/ui/label"
import { ReactNode } from "react"

interface FormFieldWrapperProps {
  icon: LucideIcon
  iconColor: string
  label: string
  error?: string
  hoverBorderColor: string
  children: ReactNode
}

export function FormFieldWrapper({ 
  icon: Icon, 
  iconColor, 
  label, 
  error, 
  hoverBorderColor,
  children 
}: FormFieldWrapperProps) {
  return (
    <div className="relative group">
      <div className={`relative p-6 bg-white/80 backdrop-blur-sm rounded-xl border-2 transition-all duration-300 ${
        error ? 'border-red-500' : `border-slate-200 ${hoverBorderColor}`
      }`}>
        <div className="flex items-center gap-3 mb-4">
          <div className={`w-10 h-10 rounded-lg ${iconColor} flex items-center justify-center`}>
            <Icon size={20} className="text-white" />
          </div>
          <Label className="text-lg font-semibold text-foreground">{label}</Label>
        </div>
        {children}
        {error && (
          <p className="text-red-500 text-sm mt-2 flex items-center gap-1">
            <AlertCircle size={14} />
            {error}
          </p>
        )}
      </div>
    </div>
  )
}
